namespace Portico.Services {
    import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
    import psga = apigateway.client;
    import psgm = apigateway.models;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface IDiagnosisService {
		getByProgramId(): angular.IPromise<pme.Diagnosis[]>;
        populate(account: pme.Account): angular.IPromise<boolean>;
        search(diagnosisCode: string, diagnosisTypes: pm.Gateway.DiagnosisType[]): ng.IPromise<pme.Diagnosis[]>;
        search(diagnosisCode: string, diagnosisTypes: pm.Gateway.DiagnosisType[], currentDiagnoses: pme.Diagnosis[]): ng.IPromise<pme.Diagnosis[]>;
        getById(diagnosisId: number): angular.IPromise<pme.Diagnosis>;
    }

    @Service('app', 'diagnosisService')
	@Inject('$q', 'DiagnosisV3Api')
    export class DiagnosisService implements IDiagnosisService {
        constructor(
            private $q: angular.IQService,
			private diagnosisV3Api: psga.DiagnosisV3Api
        ) { }

		getByProgramId(): angular.IPromise<pme.Diagnosis[]> {
			// let diagnoses: pme.Diagnosis[] = this.storageService.getItem<pme.Diagnosis[]>(pm.StorageType.Session, `diagnosis-${programId}-list`);

			const promise = // diagnoses ?
				// this.$q.when(diagnoses) :
                this.$q.when(this.diagnosisV3Api.programDiagnosisGetByProgramId()
                    .then(x => x.data.data.map(x => new pme.Diagnosis(x)))); 

			return promise.then((response: pme.Diagnosis[]) => {
				const temp: pme.Diagnosis[] = [];

				for (const diagnosis of response) {
					temp.push(new pme.Diagnosis(diagnosis));
				}

				// this.storageService.saveItem<pme.Diagnosis[]>(pm.StorageType.Session, `diagnosis-${programId}-list`, temp);

				return temp;
			});
		}

		populate(account: pme.Account): angular.IPromise<boolean> {
			const accountSessions = account.accountSessions.filter((a) => {
				return !a.surveySessionId
			}).sort((a, b) => {
				return b.sessionDate.getTime() - a.sessionDate.getTime();
			});

			if (accountSessions.length === 0) {
				return this.$q.when(false);
			}

			const accountSession = accountSessions[0];

			// TODO: wrap in an edge call
            return this.$q.when(this.diagnosisV3Api.sessionDiagnosisGet(accountSession.id).then((response) => {
				accountSession.diagnoses = [];

                for (const diagnosis of response.data.data) {
					accountSession.diagnoses.push(new pme.Diagnosis(diagnosis));
				}

				return true;
			}));
        }

		getById(diagnosisId: number): angular.IPromise<pme.Diagnosis> {
			// TODO: wrap in an edge call
            return this.$q.when(this.diagnosisV3Api.diagnosisGet(diagnosisId).then((response) => {
                return new pme.Diagnosis(response.data.data);
            }));
        }

        search(diagnosisCode: string, diagnosisTypes: pm.Gateway.DiagnosisType[], currentDiagnoses: pme.Diagnosis[] = null): ng.IPromise<pme.Diagnosis[]> {
            const search: psgm.DiagnosisSearchRequestModel  = {
                programId: null,
                diagnosisName: '',
                diagnosisDescription: '',
                diagnosisCode: diagnosisCode,
                diagnosisType: pm.Gateway.DiagnosisType.UNKN,
                maxRecordCount: 20
            };

            const currentDiagnosisCodes = currentDiagnoses !== null ? currentDiagnoses.map(x => x.id) : null;

            return this.$q.when(this.diagnosisV3Api.diagnosisSearch(search).then((response) => {
                let results: pme.Diagnosis[] = [];

                // filter out only the diagnosis types that we want to see
                response.data.data.diagnoses.filter(d => this.isInArray(d.diagnosisType, diagnosisTypes)).forEach(r => {
                    if (currentDiagnosisCodes != null) {
                        if (this.isInArray(r.diagnosisId, currentDiagnosisCodes) == false) {
                            results.push(new pme.Diagnosis(r));
                        }
                    }
                    else {
                        results.push(new pme.Diagnosis(r));
                    }
                });

                return results;
            }));
        }

        private isInArray<T>(searchValue: T, valueArray: T[]) {
            return _.findIndex(valueArray, (value: T) => {
                return value === searchValue;
            }) !== -1;
        }
    }
}